import React from 'react'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { richPromotionApi } from 'api/richPromotion'

export const RichPromotionButton = ({ productId }: { productId?: string }) => {
  const [allowed, setAllowed] = React.useState(false)
  React.useEffect(() => {
    let cancelled = false
    setAllowed(false)
    if (productId) richPromotionApi.get(productId).then(() => { if (!cancelled) setAllowed(true) }).catch(() => {})
    return () => { cancelled = true }
  }, [productId])
  return allowed ? <Link to={`/goods/edit/${productId}/promotion`}><Button size='large' block>Акция</Button></Link> : null
}
